module.exports = __webpack_public_path__ + "static/media/DART.b0758330.png";